// Council session options exposed for resource filtering.
// Council numbers 1-5 match the Year 2 council config (config/year2.php);
// no Year 1 council-name config exists, so Year 1 reuses the same 1-5 range.
// Council 6 (present only in the raw session-type dropdown) is intentionally
// excluded here — it has no backing config on either year and would always
// return zero resources.
export const COUNCIL_SESSION_OPTIONS = [
  { sessionType: 'Orientation', label: 'Orientation' },
  { sessionType: 'Council 1', label: 'Council 1' },
  { sessionType: 'Council 2', label: 'Council 2' },
  { sessionType: 'Council 3', label: 'Council 3' },
  { sessionType: 'Council 4', label: 'Council 4' },
  { sessionType: 'Council 5', label: 'Council 5' },
];

// Returns resource objects (from normalizeResources) matching a given
// sessionType ('Orientation' | 'Council N') + cohort levelYear ('Year 1' | 'Year 2').
// councilId 0 = Orientation, 1-5 = Council N.
export function filterResourcesByCouncil(resources, sessionType, cohortLevelYear) {
  let councilId;
  if (sessionType === 'Orientation') {
    councilId = 0;
  } else {
    const m = String(sessionType || '').match(/\d+/);
    councilId = m ? parseInt(m[0], 10) : null;
  }
  if (councilId === null || councilId === undefined) return [];
  const normalizedYear = String(cohortLevelYear || '').trim().toLowerCase();
  return (resources || [])
    .filter(r => (
      String(r.programName || '').trim().toLowerCase() === 'glosco'
      && Number(r.councilId) === councilId
      && String(r.levelName || '').trim().toLowerCase() === normalizedYear
      && String(r.status || '').trim().toLowerCase() === 'active'
    ))
    .sort((a, b) => a.displayOrder - b.displayOrder);
}

// Same as filterResourcesByCouncil but returns only IDs (matches the
// pre-existing getAutoResources contract used by SessionForm auto-attach).
export function filterResourceIdsByCouncil(resources, sessionType, cohortLevelYear) {
  return filterResourcesByCouncil(resources, sessionType, cohortLevelYear).map(r => r.id);
}
